module.exports = __webpack_public_path__ + "media/store/images/arrow-small-right-fe92c58a95ae4f3bf164c2233c3259de.png";